import type {
  NamedReference,
  SetupPaginatedResponse,
} from "src/services/administrationSetupService";

export const getEntityName = (value: unknown) => {
  if (typeof value === "string") return value;

  if (value && typeof value === "object") {
    const candidate = value as NamedReference;
    return String(
      candidate.name ??
        candidate.code ??
        candidate.enumName ??
        candidate.description ??
        "",
    );
  }

  return "";
};

export const isActive = (value: unknown) => {
  if (typeof value === "boolean") return value;
  if (typeof value === "number") return value === 1;
  if (typeof value === "string") {
    return ["active", "true", "1"].includes(value.toLowerCase());
  }
  return false;
};

export const getRecords = <T>(
  response: SetupPaginatedResponse<T> | undefined,
  key: "unitMakes" | "unitModels" | "parameterGroups" | "properties",
) => response?.[key] ?? response?.data ?? response?.items ?? response?.content ?? [];

export const getTotalCount = <T>(
  response: SetupPaginatedResponse<T> | undefined,
  fallback: number,
) =>
  response?.totalItems ??
  response?.totalElements ??
  response?.total ??
  fallback;

export const getLookupItems = (payload: unknown): NamedReference[] => {
  if (Array.isArray(payload)) return payload;

  if (!payload || typeof payload !== "object") return [];

  const lookupPayload = payload as {
    response?: unknown;
    data?: unknown;
    items?: unknown;
  };

  if (Array.isArray(lookupPayload.response)) return lookupPayload.response;
  if (Array.isArray(lookupPayload.data)) return lookupPayload.data;
  if (Array.isArray(lookupPayload.items)) return lookupPayload.items;

  return [];
};

export const getColumnOptions = (
  payload: unknown,
): Array<{ label: string; value: string }> => {
  const items = getLookupItems(
    (payload as { response?: unknown; data?: unknown } | undefined)?.response ??
      (payload as { data?: unknown } | undefined)?.data ??
      payload,
  );

  return items
    .map((item) => ({
      label: item.name ?? item.description ?? item.code ?? "",
      value: String(item.code ?? item.enumName ?? item.name ?? item.id ?? ""),
    }))
    .filter((option) => option.label && option.value);
};
